import { RecipeCreatePage } from "@corpuscomplete/web/modules/nutrition/recipe/pages/recipe-create";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";

export const Route = createFileRoute("/_authenticated/spaces/$spaceId/recipes/create")({
  validateSearch: z.object({
    initialCollectionId: z.uuid().optional(),
  }),
  component: () => {
    const { spaceId } = Route.useParams();
    const { initialCollectionId } = Route.useSearch();
    return (
      <RecipeCreatePage
        initialCollectionId={initialCollectionId}
        scope={{ kind: "space", spaceId }}
      />
    );
  },
});
